<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
    >
        <g>
            <ellipse cx="11.805" cy="12" rx="10.979" ry="10.979"></ellipse>
            <rect
                x="5.463"
                y="4.539"
                width="1"
                height="14.3"
                rx="0.5"
                ry="0.5"
                transform="matrix(0.707107, 0.707107, -0.707107, 0.707107, 16.048895, -0.481853)"
            ></rect>
            <rect
                transform="matrix(0.707107, -0.707107, 0.707107, 0.707107, -0.481853, 7.951105)"
                x="5.463"
                y="4.539"
                width="1"
                height="14.3"
                rx="0.5"
                ry="0.5"
            ></rect>
        </g>
    </svg>
</template>

<script>
export default {
    name: "CancelIcon"
};
</script>
